import { render, staticRenderFns } from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=template&id=4f6e5851&scoped=true&"
import script from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricReadyExtraProcessTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6e5851",
  null
  
)

export default component.exports